import { MainBorrowerPricingState } from "../types"
import { createBorrowerCartItem } from "./async/createBorrowerCartItem"
import { deleteBorrowerCartItem } from "./async/deleteBorrowerCartItem"
import { fetchShoppingCart } from "./async/fetchShoppingCart"
import { initBorrowerPricingProcessAsync } from "./async/initBorrowerPricingProcess"
import { onAdjustment } from "./async/onAdjustment"
import { onSearch } from "./async/onSearch"
import { toggleBorrowerLoan } from "./async/toggleBorrowerLoan"
import { toggleGuarantee } from "./async/toggleGuarantee"
import { togglePsyBuyback } from "./async/togglePsyBuyback"
import { onContractFunnelFeeUpdate } from "./async/onContractFunnelFeeUpdate"
import { MainBorrowerPricingAsyncActions, MainBorrowerPricingSyncActions } from "./types"
import { PricingWatchdog } from "./pricingWatchdog"

export const createBorrowerPricingAsyncActions = (
  actions: MainBorrowerPricingSyncActions,
  getState: () => MainBorrowerPricingState,
  pricingWatchdog: PricingWatchdog
): MainBorrowerPricingAsyncActions => {
  const searchAction = (loans: Parameters<typeof onSearch>[0]) => onSearch(loans, actions, getState, pricingWatchdog)

  return {
    initBorrowerPricingProcessAsync: (borrowerProjectId) => initBorrowerPricingProcessAsync(borrowerProjectId, actions, pricingWatchdog),
    toggleBorrowerLoan: (borrowerLoanId) => toggleBorrowerLoan(borrowerLoanId, actions, getState, pricingWatchdog),
    toggleGuarantee: (params) => toggleGuarantee(params, searchAction, getState),
    togglePsyBuyback: (params) => togglePsyBuyback(params, searchAction, getState),
    onSearch: searchAction,
    onAdjustments: (overrides) => onAdjustment(actions, getState, pricingWatchdog, overrides),
    fetchShoppingCart: (borrowerProjectId, borrowerId) => fetchShoppingCart(borrowerProjectId, borrowerId, actions),
    createBorrowerCartItem: (funnelId, groupContractId, borrowerIds, isGroup, borrowerProjectId, contractFunnelHash) => createBorrowerCartItem(funnelId, groupContractId, borrowerIds, isGroup, borrowerProjectId, contractFunnelHash, actions),
    deleteBorrowerCartItem: (borrowerProjectId, hash) => deleteBorrowerCartItem(borrowerProjectId, hash, actions),
    onContractFunnelFeeUpdate: (contractFunnelId, contractIdentifier, funnelHash) => onContractFunnelFeeUpdate(contractFunnelId, contractIdentifier, funnelHash, actions, getState),
  }
}
